import '../css/main.css'
import './style.css'
import Menu from '../common/menu.js';
import TopBar from "../common/topBar2";
import { useEffect, useState } from 'react';
import BaiscTable from '../tables/default-table.js';
import BasicPagination from '../pagination/basic.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.js';
import { useData } from '../../contexts/DataContext.js';
import DefaultLayout from '../layouts/DefaultLayout.js';
import toast from 'react-hot-toast';
import TopCardSkeleton from '../Skeleton/topCards.js';
import Loader from '../loaders/loader.jsx';
import * as XLSX from 'xlsx';

export default function Clients() {

const [create, setCreate] = useState(false);
const [edit, setEdit] = useState(null);
const [del, setDel] = useState(null);
const {pathname} = useLocation()
const {user,selectedMicrocredit,userRole,userInfo} = useAuth()
const data=useData()
const [loading,setLoading]=useState(false)
const navigate=useNavigate()
const [printing,setPrinting]=useState(false)
const [topFilters,setTopFilters]=useState({
     filtered_contract_year:new Date().getFullYear(),
     filtered_contract_month:new Date().getMonth()
})
const [hideFilters,setHideFilters]=useState(true)


let required_data=['contracts','clients_list']

const [currentPage,setCurrentPage]=useState(1)
const [updateFilters,setUpdateFilters]=useState(null)
const [search,setSearch]=useState('')
const [filterOptions,setFilterOptions]=useState([])
let initial_filters={start_date:'',end_date:'',approval_status:'',payment_status:'',client_id:''}
const [filters,setFilters]=useState(initial_filters);

useEffect(()=>{ 
   if(!user || data.updateTable) return
   data.handleLoaded('remove',required_data)
   data._get(required_data,{
     contracts:{legal_status:pathname.includes('/legal/contracts') ? 'legal' : '',microcredit_id:selectedMicrocredit,search:search,page:currentPage,...topFilters,...filters,...data.getParamsFromFilters(filterOptions)},
     clients_list:{microcredit_id:selectedMicrocredit},
   }) 
 },[user,pathname,search,currentPage,updateFilters])


 useEffect(()=>{
   data.handleLoaded('remove',required_data)
 },[updateFilters])



 useEffect(()=>{
   if(data.updateTable){
        data.setUpdateTable(null)
        data.handleLoaded('remove',required_data)
        setCurrentPage(1)
        data._get(required_data,{
          contracts:{legal_status:pathname.includes('/legal/contracts') ? 'legal' : '',microcredit_id:selectedMicrocredit,search:search,page:1,...topFilters,...filters,...data.getParamsFromFilters(filterOptions)},
          clients_list:{microcredit_id:selectedMicrocredit},
        }) 
   }
},[data.updateTable])


useEffect(()=>{data.setUpdateTable(Math.random())},[filters,topFilters])


const Print =async (type,_data) => {
     
let name=(user?.microcredits?.filter(i=>i.id==selectedMicrocredit)[0]?.name || '') +`${user.role!="admin" ? ' - ':' '} contratos ${data.today()} ${data.time()}`
    
     const mappedData = _data.map(item => {

          let paid_installments=item.installments.filter(i=>i.payment_histories.length)
          let last_installment=paid_installments[paid_installments.length - 1]  //
          let last_payday=last_installment?.payment_histories?.[last_installment?.payment_histories?.length - 1]?.payday?.split('T')?.[0]

          return {
               'ID':item.id,
               'Cliente':item.client.name,
               'Financiado':data._cn(item.disbursement_value),
               'Prestação':data._cn(item.disbursement_value + item.fees),
               'Juros':data._cn(item.fees) + ` (${item.fees_percentage}%)`,
               'Despesas':data._cn(item.total_expenses),
               'Pago':data._cn(item.paid),
               'Em falta':data._cn((item.total_to_pay) - (item.paid || 0) < 0 ? '0': ((item.total_to_pay) - (item.paid || 0)).toFixed(2)),
               'Estado de aprovação':item.approval_status=='pending' || !item.approval_status ? 'Pendente':  item.approval_status=="approved" ? 'Aprovado' :  item.approval_status=="parcial" ? 'Parcialmente' : 'Rejeitado',
               'Estado de pagamento':item.payment_status=='pending' || !item.payment_status ? 'Pendente':  item.payment_status=="paid" ? 'Pago' :  item.payment_status=="parcial" ? 'Parcialmente' : item.payment_status=="delayed" ? 'Atrasado' : 'Atrasado',
               'Estado jurídico':item.legal_status=="normal" ? 'Normal' : 'Em risco',
               'Juros de mora':data._cn(item.late_payment_interest),
               'Data de desembolso':item.disbursement_date.split('-')?.reverse().join('-'),
               'Data de reembolso':item.refund_date.split('-')?.reverse().join('-'),
               "Bens associados":item.contract_assets?.length || 0,
               "Data do último pagamento":last_payday?.split('-')?.reverse()?.join('-') || "",
               "Número de parcelas":item.installments.length,
               "Criado por":item.micro_user?.name || '-',
               'Dias em falta': item.payment_status=="paid" ? '-' : item.left_days == 0 ? "Hoje" : item.left_days < 0 ? - item.left_days+" dias atrás" : item.left_days,
               'Data de criação':item.created_at.split('T')[0].split('-')?.reverse().join('-'),
               'Notas':item.notes,
               'Finalidade':item.reason
          }
     }); 


     const mappedDataPDF = _data.map(item => {
        
          return {
               'ID':item.id,
               'Cliente':item.client.name,
               'Financiado':data._cn(item.disbursement_value),
               'Prestação':data._cn(item.disbursement_value + item.fees),
               'Despesas':data._cn(item.total_expenses),
               'Juros':data._cn(item.fees) + ` (${item.fees_percentage}%)`,
               'Pago':data._cn(item.paid),
               'Em falta':data._cn((item.total_to_pay) - (item.paid || 0) < 0 ? '0': ((item.total_to_pay) - (item.paid || 0)).toFixed(2)),
               'Estado de aprovação':item.approval_status=='pending' || !item.approval_status ? 'Pendente':  item.approval_status=="approved" ? 'Aprovado' :  item.approval_status=="parcial" ? 'Parcialmente' : 'Rejeitado',
               'Estado de pagamento':item.payment_status=='pending' || !item.payment_status ? 'Pendente':  item.payment_status=="paid" ? 'Pago' :  item.payment_status=="parcial" ? 'Parcialmente' : item.payment_status=="delayed" ? 'Atrasado' : 'Atrasado',
               'Juros de mora':data._cn(item.late_payment_interest),
               'Data de desembolso':item.disbursement_date.split('-')?.reverse().join('-'),
               'Data de reembolso':item.refund_date.split('-')?.reverse().join('-'),
               "Bens":item.contract_assets?.length || 0,
          }
     }); 


     if(type=="excel"){
          const workbook = XLSX.utils.book_new();
          const sheetData = XLSX.utils.json_to_sheet(mappedData);
          XLSX.utils.book_append_sheet(workbook, sheetData, 'Sheet1');
          XLSX.writeFile(workbook, `${name}.xlsx`);
     }else{
          data.setPrintData({print:true,data:[mappedDataPDF],names:[name]})
     }

}






const Export =async (type) => {
      
      try{
          setPrinting(true)
          let response=await data.makeRequest({method:'get', url:`api/contracts`,params:{
              legal_status:pathname.includes('/legal/contracts') ? 'legal' : '',
              all:true,microcredit_id:selectedMicrocredit || '',search:search,page:currentPage,...filters,...data.getParamsFromFilters(filterOptions)
          }, error: ``,withToken:true},0);
          Print(type,response.data)
      }catch(e){
          toast.remove()
          let msg="Acorreu um erro, tente novamente"
          if(e.response){
            if(e.response.status==500){
                msg="Erro, inesperado. Contacte seu administrador"
            }
          }else if(e.code=='ERR_NETWORK'){
                msg="Verfique sua internet e tente novamente"
          }
          toast.error(msg)
      }
      setPrinting(false)
}


async function handleItems({approval_status,id,from,status}){ 

     data._closeAllPopUps()
     toast.remove()
     toast.loading('A actualizar...') 
     setLoading(true)
    
     try{
         
       if(from=="legal_status"){

          await data.makeRequest({method:'post',url:'api/contracts/change-legal-status',withToken:true,data:{
               status,
               id
         }, error: ``},0);

       }else{

          await data.makeRequest({method:'post',url:`api/contracts/approval-status`,withToken:true,data:{
               approval_status,
               id
         }, error: ``},0);
       }

        toast.remove()
        toast.success("Actualizado com sucesso")
        data.setUpdateTable(Math.random())
  
     }catch(e){
        toast.remove()
        let msg="Acorreu um erro, tente novamente"
  
        setLoading(false)
  
        if(e.response){
          if(e.response.status==409){
            msg="Nome já existe"
          } 
          if(e.response.status==404){
              msg="Item não encontrado"
              setEdit(null)
          }
          if(e.response.status==500){
              msg="Erro, inesperado. Contacte seu administrador"
          }
        }else if(e.code=='ERR_NETWORK'){
              msg="Verfique sua internet e tente novamente"
        }

        toast.error(msg)
  
     }
  }
  
 useEffect(()=>{
             if((userRole=="operator" && !userInfo?.permissions?.contracts?.includes('read')) && !pathname.includes('/legal/contracts')){
               navigate('/dashboard')
             }
             if((userRole=="operator" && !userInfo?.permissions?.legal_guidelines?.includes('read')) && pathname.includes('/legal/contracts')){
               navigate('/dashboard')
             }
 },[userInfo])

return (
    <>
     
     <DefaultLayout>

     <main className="dashboard-container">
   
     <div className="dashboard">
     <Menu/>
     <div className="main-dashboard">
          <TopBar homePage={true} activePage={pathname.includes('/legal/contracts') ?  'Contratos de risco'  : 'Contratos' }/>
          {(!data.loaded.includes('contracts') && !pathname.includes('/legal/contracts')) && <TopCardSkeleton/>}

          <div className="center">
          <div style={{display:(!data.loaded.includes('contracts') || pathname.includes('/legal/contracts'))  ? 'none':'flex'}} className={`stat_page_2`}>
                             <div className="items">
                                  <div className="box">
                                   <div className="absolute -translate-y-[50%] border top-0 left-4 bg-white shadow rounded-full flex items-center overflow-hidden">
                                        <select onChange={(e)=>setTopFilters({...topFilters,filtered_contract_month:e.target.value})} value={topFilters.filtered_contract_month} className="text-[0.8rem] outline-none border-r border-r-black mr-2">
                                             {(data.months).map((i,_i)=>(
                                               <option value={_i}>{i}</option>
                                             ))}
                                        </select>
                                        <select onChange={(e)=>setTopFilters({...topFilters,filtered_contract_year:e.target.value})} value={topFilters.filtered_contract_year} className="text-[0.8rem] outline-none">
                                             {(data._contracts.contractsYearsFromStart || [new Date().getFullYear()]).map((i,_i)=>(
                                               <option value={i}>{i}</option>
                                             ))}
                                        </select>
                                   </div>

                                    <div className="icon blue-icon">
                                       <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" className="opacity-[0.8]"><path d="m480-320 56-56-64-64h168v-80H472l64-64-56-56-160 160 160 160Zm0 240q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"></path></svg>
                                    </div>
                                    <div className="center-content">
                                       <div className="name">Financiado</div>
                                       <div className="total">{data._cn((data._contracts?.globalTotals?.disbursementValue || 0).toFixed(2))}</div>
                                    </div>
                                 </div>
                                   <div className="box">
                                    <div className="icon green-icon">
                                       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="27"><path d="M444-200h70v-50q50-9 86-39t36-89q0-42-24-77t-96-61q-60-20-83-35t-23-41q0-26 18.5-41t53.5-15q32 0 50 15.5t26 38.5l64-26q-11-35-40.5-61T516-710v-50h-70v50q-50 11-78 44t-28 74q0 47 27.5 76t86.5 50q63 23 87.5 41t24.5 47q0 33-23.5 48.5T486-314q-33 0-58.5-20.5T390-396l-66 26q14 48 43.5 77.5T444-252v52Zm36 120q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"></path></svg>
                                    </div>
                                    <div className="center-content">
                                       <div className="name">Recebido</div>
                                       <div className="total">{data._cn((data._contracts?.globalTotals?.paid || 0).toFixed(2))}</div>
                                    </div>
                                 </div>

                                   <div className="box">
                                    <div className="icon red-icon">
                                         <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" className="opacity-[0.8]"><path d="M574-618q-12-30-35.5-47T482-682q-18 0-35 5t-31 19l-58-58q14-14 38-25.5t44-14.5v-84h80v82q45 9 79 36.5t51 71.5l-76 32ZM792-56 608-240q-15 15-41 24.5T520-204v84h-80v-86q-56-14-93.5-51T292-350l80-32q12 42 40.5 72t75.5 30q18 0 33-4.5t29-13.5L56-792l56-56 736 736-56 56Z"></path></svg>
                                    </div>
                                    <div className="center-content">
                                       <div className="name">Em falta</div>
                                       <div className="total">
                                        {data._cn((data._contracts?.globalTotals?.left || 0).toFixed(2))}
                                      </div>
                                    </div>
                                 </div>

                                 <div className="box">
                                    <div className="icon orange-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" className="opacity-[0.8]"><path d="M440-200h80v-40h40q17 0 28.5-11.5T600-280v-120q0-17-11.5-28.5T560-440H440v-40h160v-80h-80v-40h-80v40h-40q-17 0-28.5 11.5T360-520v120q0 17 11.5 28.5T400-360h120v40H360v80h80v40ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-560v-160H240v640h480v-480H520ZM240-800v160-160 640-640Z"></path></svg>
                                    </div>
                                    <div className="center-content">
                                       <div className="name">Esperado</div>
                                       <div className="total">{data._cn((data._contracts?.globalTotals?.expected || 0).toFixed(2))}</div>
                                    </div>
                                 </div>
                             </div>
               </div>



               <div className="center_search">

                    <div className="search_container">
                         <div className="search-div">
                              <input type="text" placeholder="Pesquisar cliente..." value={search} onChange={(e)=>{
                                   setSearch(e.target.value)
                                   data.setUpdateTable(Math.random())
                              }}/>
                                   <div className="search-btn">
                                   <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                              </div>
                         </div>
                    </div>

                    <div className="flex items-center">
                         <div onClick={()=>
                         data.setUpdateTable(Math.random())
                         } className="mr-2 cursor-pointer hover:opacity-65">
                              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"/></svg>
                         </div>
                         {(!pathname.includes('/legal/contracts') && (userRole!="operator" || userInfo?.permissions?.contracts?.includes('create'))) && <div className="btn-add-item" onClick={()=>{
                               navigate('/loans/create')
                         }}>
                                   <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path fill="#fff" d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"></path></svg>
                                   <span>Adicionar</span>
                         </div>}
                    </div>
               </div>


                    <div className={`extra-filters ${hideFilters ? '_hide':''}`}>

                     <label onClick={()=>setHideFilters(!hideFilters)} className="underline sm:hidden text-[15px]  text-custom_blue-400 absolute top-4 cursor-pointer">{hideFilters ? 'Mostrar filtros':'Esconder filtros'}</label>

                     <div className="input-container">

                         <div className="inputs">
                              <span>Data de inicio</span>
                              <input type="date" value={filters.start_date} onChange={(e)=>setFilters({...filters,start_date:e.target.value})} />
                         </div>

                              <div className="inputs">
                              <span>Data de fim</span>
                              <input type="date" value={filters.end_date} onChange={(e)=>setFilters({...filters,end_date:e.target.value})} />
                         </div>

                         {!pathname.includes('/legal/contracts') && <div className="inputs">
                              <span>Estado de pagamento</span>
                              <select value={filters.payment_status} onChange={e=>setFilters({...filters, payment_status:e.target.value})}>
                                   <option  selected value="">Selecionar estado</option>
                                   <option  value={'pending'}>Pendente</option>
                                   <option  value={'paid'}>Pago</option>
                                   <option  value={'delayed'}>Atrasado</option>
                                   <option  value={'restructured'}>Restruturado</option>
                              </select>
                         </div>}

                         {!pathname.includes('/legal/contracts') &&<div className="inputs">
                              <span>Estado de aprovação</span>
                              <select value={filters.approval_status} onChange={e=>setFilters({...filters, approval_status:e.target.value})}>
                                   <option  selected value="">Selecionar estado</option>
                                   <option  value={'pending'}>Pendente</option>
                                   <option  value={'approved'}>Aprovado</option>
                                   <option  value={'rejected'}>Rejeitado</option>
                              </select>
                         </div>}

                        
                         <div className="inputs">
                              <span>Cliente</span>
                              <select value={filters.client_id} onChange={e=>setFilters({...filters, client_id:e.target.value})}>
                                        <option selected value="">Selecionar cliente</option>
                                        {data._clients_list.sort((a, b) => (a.deleted_at === null ? -1 : 1) - (b.deleted_at === null ? -1 : 1)).map(i=>(
                                             <option key={i.id} selected={filters.client_id === i.id} value={i.id}>{i.name} {i.deleted_at ? '(Arquivado)':''}</option>
                                        ))}
                              </select>
                         </div>
                         
                         
                    </div>

                    <div className="options">
                    <span onClick={()=>setFilters(initial_filters)}>
                         <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path fill="#fff" d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z"/></svg> </span>
                    </div>
             </div>

               <div className="dasboard-item-list-container">
                    <div className="top-section">
                         <div className="left-side">
                                   <div className="show">
                                             <span>Resultados:</span>
                                             <label>{data._contracts?.total || 0}</label>
                                   </div>
                                   <div className="show">
                                             <span>Financiado:</span>
                                             <label>{data._cn((data._contracts?.filteredTotals?.disbursementValue || 0).toFixed(2))}</label>
                                   </div>
                                   <div className="show">
                                             <span>Recebido:</span>
                                             <label>{data._cn((data._contracts?.filteredTotals?.paid || 0).toFixed(2))}</label>
                                   </div>
                                   <div className="show">
                                             <span>Em falta:</span>
                                             <label>{data._cn((data._contracts?.filteredTotals?.left || 0).toFixed(2))}</label>
                                   </div>
                                   <div className="show">
                                             <span>Esperado:</span>
                                             <label>{data._cn((data._contracts?.filteredTotals?.expected || 0).toFixed(2))}</label>
                                   </div>
                              
                         </div>
                        
                         <div className="right-side">
                                        {printing ? <>
                                                  <Loader/>
                                        </> : <>
                                             <span onClick={()=>{
                                                  Export('pdf')
                                             }} className="export export-excel page" style={{background:'rgb(74, 205, 53)'}}>
                                                  <svg width="21" viewBox="0 0 24 24" style={{fill:'#fff'}} xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M9 12.5H10V10.5H11C11.2833 10.5 11.5208 10.4042 11.7125 10.2125C11.9042 10.0208 12 9.78333 12 9.5V8.5C12 8.21667 11.9042 7.97917 11.7125 7.7875C11.5208 7.59583 11.2833 7.5 11 7.5H9V12.5ZM10 9.5V8.5H11V9.5H10ZM13 12.5H15C15.2833 12.5 15.5208 12.4042 15.7125 12.2125C15.9042 12.0208 16 11.7833 16 11.5V8.5C16 8.21667 15.9042 7.97917 15.7125 7.7875C15.5208 7.59583 15.2833 7.5 15 7.5H13V12.5ZM14 11.5V8.5H15V11.5H14ZM17 12.5H18V10.5H19V9.5H18V8.5H19V7.5H17V12.5ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM8 16H20V4H8V16ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6H4V20H18V22H4Z" />
                                                  </svg>
                                             </span>
                                             
                                             <span onClick={()=>{
                                                  Export('excel')
                                             }} className="export export-excel page" style={{background:'rgb(74, 205, 53)'}}>
                                             <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24"><path fill="#fff" d="M18 22a2 2 0 0 0 2-2v-5l-5 4v-3H8v-2h7v-3l5 4V8l-6-6H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12zM13 4l5 5h-5V4z"></path></svg>
                                             </span>
                                        </>}
                         </div>

                    </div>


               <BaiscTable  canAdd={user?.role=="admin"} addRes={()=>{
                     setCreate(true)
                }}  loaded={data._loaded.includes('contracts')} header={[
                    <BaiscTable.MainActions hide={userRole=="operator" && !userInfo?.permissions?.contracts?.includes('delete')} data={data} options={{
                    deleteFunction:'default',
                    deleteUrl:'api/contracts/delete'}
                    } items={data._contracts?.data || []}/>,

                    'ID',
                    'Data de criação',
                    'Cliente',
                    'Financiamento',
                    'Prestação',
                    'Pago',
                    'Em falta',
                    'Estado de pagamento',
                    'Estado de aprovação',
                    'Despesas',
                    'Juros',
                    'Juros de mora',
                    'Total por pagar',
                    'Data de desembolso',
                    'Data de reembolso',
                    'Dias em falta',
                    'Dias de atraso',
                    "Número de parcelas",
                    'Nota',
                    'Finalidade do crédito'
                    ]
               }

               body={(data._contracts?.data || []).map((i,_i)=>(
                    
                         <BaiscTable.Tr>
                         <BaiscTable.Td>
                              <BaiscTable.Actions hide={userRole=="operator" && !userInfo?.permissions?.contracts?.includes('delete')} data={data}  options={{
                                   deleteFunction:'default',
                                   deleteUrl:'api/contracts/delete',
                                   id:i.id}
                              }/>
                         </BaiscTable.Td>

                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{i.id}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._c_date(i.created_at).split('T')[0]?.split('-')?.reverse()?.join('/')} {data._c_date(i.created_at).split('T')[1].slice(0,5)}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{i.client?.name || '-'}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._cn(i.disbursement_value.toFixed(2))}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._cn((i.disbursement_value + i.fees).toFixed(2))}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._cn(i.paid.toFixed(2))}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._cn((i.total_to_pay) - (i.paid || 0) < 0 ? '0': ((i.total_to_pay) - (i.paid || 0)).toFixed(2))}</BaiscTable.Td>
                         
                       

                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>
                            <button style={{ backgroundColor:i.payment_status=='restructured' ? '#1757dbad': !i.payment_status || i.payment_status=='pending' || i.payment_status=='parcial' ? '#eab308': i.payment_status=="paid" ? '#4ACD35' : '#f82f54bf', border:0}} type="button"  class={`cursor-default text-gray-900 focus:outline-none  font-medium rounded-[0.3rem] text-sm px-2 py-1 text-center inline-flex items-center`}>
                                 {i.payment_status=='restructured' ? 'Restruturado': i.payment_status=='pending' || !i.payment_status ? 'Pendente':  i.payment_status=="paid" ? 'Pago' :  i.payment_status=="parcial" ? 'Parcialmente' : i.payment_status=="delayed" ? 'Atrasado' : 'Atrasado'}
                            </button>
                         </BaiscTable.Td>
                            
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>
                            <button style={{ backgroundColor:!i.approval_status || i.approval_status=='pending' || i.approval_status=='parcial' ? '#eab308': i.approval_status=="approved" ? '#4ACD35' : '#f82f54bf', border:0}} type="button"  class={`text-gray-900 cursor-default   focus:outline-none  font-medium rounded-[0.3rem] text-sm px-2 py-1 text-center inline-flex items-center`}>
                                {i.approval_status=='pending' || !i.approval_status ? 'Pendente':  i.approval_status=="approved" ? 'Aprovado' :  i.approval_status=="parcial" ? 'Parcialmente' : 'Rejeitado'}
                            </button>
                         </BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._cn((i.total_expenses).toFixed(2))}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._cn(i.fees.toFixed(2))} {`(${i.fees_percentage}%)`}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._cn(i.late_payment_interest.toFixed(2))}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data._cn(i.total_to_pay.toFixed(2))}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{i.disbursement_date?.split('-')?.reverse()?.join('/')}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{i.refund_date?.split('-')?.reverse()?.join('/')}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{i.left_days==0 ? 'Hoje' : i.payment_status!="paid" &&  i.left_days < 0 ? `${-i.left_days} dias atrás` : i.payment_status=="paid" && i.left_days < 0 ?  0  : i.left_days}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{i.delay}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{i.installments.length}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data.text_l(i.notes,40)}</BaiscTable.Td>
                         <BaiscTable.Td onClick={()=>navigate('/loan/'+i.id)}>{data.text_l(i.reason,40)}</BaiscTable.Td>
                         <BaiscTable.AdvancedActions data={data} w={200} id={i.id} items={[
                             {name:'Eliminar',hide:(userRole!="manager" && !userInfo?.permissions?.contracts?.includes('delete')),onClick:()=>{
                                   setTimeout(()=>{
                                         data.setItemsToDelete({...data.itemsToDelete,url:'api/contracts/delete',items:[i.id]})
                                         data._showPopUp('delete')
                                   },100)
                              },icon:(<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#5f6368"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"></path></svg>)},
                              {name:'Encaminhar para Jurídico',hide:!pathname.includes('/legal/contracts') ||  i.legal_status=="legal" || (userRole!="manager" && !userInfo?.permissions?.legal_guidelines?.includes('add')),onClick:()=>{
                                   handleItems({status:'legal',id:i.id,from:'legal_status'})
                              }},
                              {name:'Remover do Jurídico',hide:!pathname.includes('/legal/contracts') ||  i.legal_status=="normal" || (userRole!="manager" && !userInfo?.permissions?.legal_guidelines?.includes('remove')),onClick:()=>{
                                   handleItems({status:'normal',id:i.id,from:'legal_status'})
                              }},
                              {name:'Rejeitar',hide:i.approval_status=="rejected" || (userRole!="manager" && !userInfo?.permissions?.contracts?.includes('reject')),onClick:()=>{handleItems({approval_status:'rejected',id:i.id})},icon:(<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>)},
                              {name:'Aprovar',hide:i.approval_status=="approved"  || (userRole!="manager" && !userInfo?.permissions?.contracts?.includes('approve')),onClick:()=>{handleItems({approval_status:'approved',id:i.id})},icon:(<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>)},
                          ]}/>
                    </BaiscTable.Tr>
                    ))}
          />

               <BasicPagination show={data._loaded.includes('contracts')} from={'contracts'} setCurrentPage={setCurrentPage} total={data._contracts?.total}  current={data._contracts?.page} last={data._contracts?.totalPages}/>


               </div>

          </div>

          
     </div>
     </div>
     </main>

     </DefaultLayout>
    </>
  );
}
